import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";
import {Product} from "../../models/product";


@Component({
    selector: 'additional-product-info-dialog',
    templateUrl: './additionalProductInfoDialog.component.html',
    styleUrls: ['./additionalProductInfoDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class AdditionalProductInfoDialogComponent {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;
    product: Product;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<AdditionalProductInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.product = _data.product;
        this.translationLoader.loadTranslations(polish);
    }
}
